export default __webpack_public_path__ + "static/6830-5f5ca882eb1db45432f789e76d43cbe5.jpg";